import { createSlice } from "@reduxjs/toolkit";
import { WalletType } from "../../types/walletType";
import { fetchWalletTypesThunk } from "../thunk/walletTypesThunk";

export interface WalletTypesState {
  walletTypes: WalletType[];
}

const initialState: WalletTypesState = {
  walletTypes: [],
};

export const walletTypesSlice = createSlice({
  name: "walletTypes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchWalletTypesThunk.fulfilled, (state, action) => {
      state.walletTypes = action.payload;
    });
  },
});

export default walletTypesSlice.reducer;
